import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'preview',
    loadComponent: () =>
      import('./pages/preview/preview.component').then((m) => m.PreviewComponent),
  },
  {
    path: 'offer/:trackingToken/:offerId',
    loadComponent: () =>
      import('./pages/offer/offer.component').then((m) => m.OfferPageComponent),
  },
  {
    path: 'imprint',
    loadComponent: () =>
      import('./pages/legal/legal-page.component').then((m) => m.LegalPageComponent),
    data: { pageType: 'imprint' },
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/legal/legal-page.component').then((m) => m.LegalPageComponent),
    data: { pageType: 'privacy' },
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then((m) => m.NotFoundComponent),
  },
  {
    path: '',
    loadComponent: () =>
      import('./pages/booking/booking.component').then((m) => m.BookingComponent),
  },
  {
    // Behavioural change (#455 / parent #448): unknown URLs render the 404 page
    // instead of silently redirecting to the booking flow. External integrations
    // (QR codes, marketing links) relying on the previous silent-redirect behaviour
    // will surface a 404 page now.
    path: '**',
    redirectTo: 'not-found',
  },
];
